import { render, staticRenderFns } from "./CreateProjectLeadModal.vue?vue&type=template&id=2264a810&"
import script from "./CreateProjectLeadModal.vue?vue&type=script&lang=js&"
export * from "./CreateProjectLeadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports